import type { TenantAccessUser } from "./tenant-access";
import { checkTenantAccess } from "./tenant-access";

export type TenantPublicStatus = "online" | "offline";

export type TenantPublicSurface = "fm" | "bh";

export const STRUCTURA_PLATFORM_URL = "https://structura.com.ar";
export const STRUCTURA_PLATFORM_HOST = "structura.com.ar";

export const TENANT_PUBLIC_STATUS_CHANGED_EVENT = "tenant_public_status_changed";

export type TenantPublicStatusRecord = {
  status: TenantPublicStatus;
  offlineReason?: string | null;
  offlineUpdatedAt?: string | null;
  offlineUpdatedBy?: string | null;
};

export function normalizeTenantPublicStatus(raw: unknown): TenantPublicStatus {
  return raw === "offline" ? "offline" : "online";
}

export function isTenantPublicOnline(status: TenantPublicStatus | string | null | undefined): boolean {
  return normalizeTenantPublicStatus(status) === "online";
}

/** Roles de workspace que omiten la cortina pública (admin/operación). */
export function canBypassTenantPublicCurtain(
  user: TenantAccessUser | null | undefined,
  tenantId: string,
): boolean {
  if (!user) return false;
  return checkTenantAccess(user, tenantId).ok;
}

export function tenantPublicOfflineCopy(
  surface: TenantPublicSurface,
  tenantName: string,
): string {
  const name = tenantName.trim() || "nuestro negocio";
  if (surface === "bh") {
    return `Estamos ajustando algunos detalles para brindarte una mejor experiencia en ${name}.\n\nSi necesitás reservar o comunicarte, podés hacerlo directamente por WhatsApp.`;
  }
  return `En este momento estamos preparando novedades y actualizando la experiencia de ${name} para ofrecerte una mejor atención.\n\nMientras tanto, podés escribirnos directamente por WhatsApp.`;
}

export function tenantPublicWhatsAppPrefill(surface: TenantPublicSurface): string {
  return surface === "bh"
    ? "Hola, quisiera consultar disponibilidad."
    : "Hola, quería hacer un pedido.";
}

/** E.164 digits only → wa.me link. */
export function buildTenantWhatsAppUrl(phone: string, message: string): string | null {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 8) return null;
  const text = encodeURIComponent(message.trim());
  return `https://wa.me/${digits}${text ? `?text=${text}` : ""}`;
}

export function tenantPublicToggleConfirmMessage(surface: TenantPublicSurface): string {
  const channel = surface === "bh" ? "widget" : "tienda";
  return `Tu ${channel} dejará de estar disponible públicamente.\nLos administradores y operadores seguirán teniendo acceso normalmente.`;
}
